import eplSession from 'src/apis/eplSession';
import serviceExports from 'src/configuration/serviceExports';

const aiAdminApi = serviceExports.aiFormAdminApiUrl;

export const xpmApi: any = () => {

    //cb.core.iam.getAuthenticationToken()

    const post = async (para1: any, path: any, body: any) => {
        path = path.replace('save', 'admin').trim(); //handle old existing calls
        if (!path.startsWith('/')) {
            path = '/' + path;
        }
        const apiUrl = aiAdminApi + path; //'/save?key=support';
        // console.log('POST ('+para1+'): ' + apiUrl + " -- body: " + JSON.stringify(body));

        const auth = await eplSession.getAuthorizationToken();

        const request = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth
            },
            body: JSON.stringify(body)
        };
        return await fetch(apiUrl, request).then((response) => response.json());
    };

    return { post };
};

export const API = xpmApi();